import React from 'react';
import Sectitle from '../Title/Sectitle';
import Teamitem from '../Team/Teamitem';
import Reveal from 'react-reveal';

const AppTeam = () => {
    return (
        <section className="experts_team_area sec_pad" id="team">
            <div className="container">
                <Sectitle sClass="sec_title text-center mb_70" Title="The <\BackSlash> Team" tClass="t_color3"
                          TitleP="The Perfect team with balanced abilities to fulfil the requirements.!"/>
                <Reveal bottom cascade>
                    <div className="row">
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_1.png" memberN="Viraj Konthasinghe"
                                      memberd="Role: Software Architect, Undergraduate Software Engineering at SLIIT"
                                      role="Leader" url1="https://www.facebook.com/vt.konthasinghe"
                                      url2="https://www.linkedin.com/in/viraj-konthasinghe/"
                                      url3="https://twitter.com/VirajIglesias"
                                      url4="https://www.instagram.com/viraj_thanuja/"/>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_2.png" memberN="Kavindi Gunasinghe"
                                      memberd="Role: Software Engineer, Undergraduate Software Engineering at SLIIT"
                                      role="Member" url1="https://www.facebook.com/kavindi.gunasinghe.9 "
                                      url2=" https://www.linkedin.com/in/kavindi-gunasinghe-68816a160/"
                                      url3="https://twitter.com/KavindiGunasin1"
                                      url4="https://www.instagram.com/__kavindi_____/"/>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_3.png" memberN="Senura Diwantha"
                                      memberd="Role: UI/UX Engineer, Undergraduate Software Engineering at SLIIT"
                                      role="Member" url1="https://www.facebook.com/Senura.Diwantha"
                                      url2="https://www.linkedin.com/in/senura-diwantha-381b3a193/"
                                      url3="https://twitter.com/DiwanthaSenura"
                                      url4="https://www.instagram.com/_____senuuu__/"/>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_4.png" memberN="Hiruni Malaviarachchi"
                                      memberd="Role: Software Engineer, Undergraduate Software Engineering at SLIIT"
                                      role="Member" url1="https://www.facebook.com/hiru.wasana"
                                      url2="https://www.linkedin.com/in/hiruni-malaviarachchi-346a4616b/"
                                      url3="https://twitter.com/HMalaviarachchi"
                                      url4="https://www.instagram.com/__hiruuuunii___/"/>
                        </div>
                    </div>
                </Reveal>

                <br/>
                <br/>

                <Sectitle sClass="sec_title text-center mb_70" Title="The Expert Support" tClass="t_color3"
                          TitleP="Help of the Experts is essential for such a huge journey. Thank you !"/>
                <Reveal bottom cascade>
                    <div className="row">
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_5.png" memberN="Ms. Disni Sriyaratna"
                                      memberd="Lecturer, Faculty of Computing, Computer Science & Software Engineering"
                                      role="Supervisor"/>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_6.png" memberN="Dr. Dharshana Kasthurirathna"
                                      memberd="Assistant Professor, Faculty of Computing, Computer Science & Software Engineering"
                                      role="Co-Supervisor"/>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_7.png" memberN="Mr. J.B.S.K.Jayantha"
                                      memberd="Graduate, Faculty of Agriculture, University of Peradeniya"
                                      role="Industrial Expert"/>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <Teamitem teamImage="team_8.png" memberN="Ms. Hasini Hewawitharana"
                                      memberd="Graduate, Faculty of Agriculture, University of Peradeniya"
                                      role="Industrial Expert"/>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>

    )
}
export default AppTeam;
